jQuery.noConflict();

(function($) {

    $(document).ready(function($){

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;


        $(document).find('*[data-fancybox], .fancybox').fancybox();


        if (isMobile && !$('.gallery-grid').hasClass('no-slick')) {

            $('.gallery-grid').slick({
                dots: false,
                slidesToShow: 1,
                autoplay: false
            });


        }

        // GMAPS LANDING START



        // GMAPS LANDING END

           // Open the first content-box by default
        $('.content-box:first').addClass('active');

        // Add the 'active' class to the corresponding swapper-link
        $('.swapper-link:first').addClass('active');


        $('.swapper-link').on('click', function(e) {
            e.preventDefault();

            $('.swapper-link').removeClass('active');
            $(this).addClass('active');

            var clickedLinkValue = $(this).attr('value');

            console.log(clickedLinkValue); 

            $('.content-box').removeClass('active');

            $('#content-'+clickedLinkValue).addClass('active');

              // Remove the 'active' class from all SVGs
            $('svg').removeClass('active');

            $(this).find('svg').addClass('active');

            
        });

        //console.log(isHistoryPage);
        if(typeof isHistoryPage === 'undefined') {
            $(".owl-carousel").owlCarousel(
                {
                    loop: true,
                    nav: true,
                    center: true,
                    items: 1,
                    dotsContainer: '#carousel-custom-dots',
                    navContainer: $('.custom-nav'),
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    navText: ["<img class='arrow-previous' src='/wp-content/themes/emigma/assets/svg/arrow.svg'>", "<img src='/wp-content/themes/emigma/assets/svg/arrow.svg'>"],
                }
            );
        } else if($(".owl-carousel").length > 0) {
            $(".owl-carousel").owlCarousel(
                {
                    loop: false,
                    center: true,
                    items: 5,
                    margin: 30,
                    scrollbarType: "scroll",
                }
            );
        }

        $('.owl-dot').on('click', function () {
            $(".owl-carousel").trigger('to.owl.carousel', [$(this).index(), 300]);
        });

        $('#emi-notice').on('closed.bs.alert', function () {
            setCookie('hideNotice', true, 1);
        });

        $('.furniture-content-nav .nav-item a:first').tab('show');

        (function () {

            $(document).on('gform_confirmation_loaded', function(event, formId){
                if(formId == 16) {
                    $('.download-catalog').show();
                }
            });


            if(typeof(gform) !== 'undefined') {
                /*
                    @roman
                    @task desc: hypelink modification for gravity forms with target attribute set to _blank
                */

                gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
                    //append attribute to links
                    if($(elem).attr('id') === 'input_11_11'){
                        $('#gform_fields_11').find('a:not([target])').each(function(i, e){
                            $(e).attr('target','_blank');
                            console.log('hl %s mod', i);
                        });
                    }
                }, 10, 3 );

            }

            let $overlay = $('.overlay');
            $(document).on('show.bs.dropdown', function () {
               $overlay.addClass('active');
            });

            $(document).on('hide.bs.dropdown', function () {
                $overlay.removeClass('active');
            });

        })();

        (function () {

                let el = $('#search-query-input'),
                    cache = [];

                function search(query, callback) {
 
                    $.ajax({
                        'method': 'post',
                        'url': localize.ajaxurl,
                        'data': {
                            q: query,
                            action: 'emigma_ajax_search'
                        },
                        'success': function (payload) {

                            console.log(JSON.parse(payload));
                            // var results = payload.places.concat(payload.clubs).concat(payload.girls);
                            // cache[query] = JSON.stringify(results);
                            callback(JSON.parse(payload));
                        }
                    });
                }

                el.autocomplete({
                    autoselect: true, // Select 1st item × search on enter UX
                    autoselectOnBlur: false, // On mobile devices = true @todo
                    openOnFocus: true,
                    // keyboardShortcuts: ['s'],
                    minLength: 4,
                }, [
                    {
                        source: search,
                        debounce: 1000,
                        displayKey: function(suggestion) {
                            return suggestion.name
                        },
                        templates: {
                            suggestion: function(suggestion) {
                                var query = $('#search-query-input').autocomplete('val');
                                var regExp = new RegExp('(' + query + ')', 'giu');
                                return '<div class="suggestion-item">' +
                                            '<div class="suggestion-cpt">' + suggestion.cpt + '</div>' +
                                            '<div class="suggestion-title">' +
                                                suggestion.name.replace(regExp, '<span class="highlight">$1</span>')
                                            + '</div>' +
                                            '<div class="suggestion-excerpt">' +
                                            suggestion.excerpt.replace(regExp, '<span class="highlight">$1</span>')
                                            + '</div>'
                                        + '</div>';
                            },
                            empty: function() {
                                return '<div class="suggestion-item"><span>'+localize.translations.noResults+'<span></div>';
                            }
                        }
                    }
                ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
                    window.location.assign(suggestion.link);
                });

        })();

        (function () {
            let sTrigger = $('#search-trigger'),
                sWrapper = $('#search-wrapper'),
                $body = $('body'),
                $overlay = $('.overlay'),
                $close = sWrapper.find('.close');

            sWrapper.open = false;
            sWrapper.toggler = function(){
                this.toggleClass('active');
                $body.toggleClass('overlay-active').toggleClass('prevent-scroll');
                sWrapper.open = !sWrapper.open;
            };
            sWrapper.closer = function() {
                this.removeClass('active');
                $body.removeClass('overlay-active').removeClass('prevent-scroll');
                sWrapper.open = false;
            };

            sTrigger.on('click', function (e) {
               e.preventDefault();
               sWrapper.toggler();
            });

            $close.add($overlay).on('click', function (e) {
                e.preventDefault();
               sWrapper.closer();
            });
        })();


        (function () {
            let $searchWrapper = $('#search-wrapper'),
                $searchForm = $searchWrapper.find('#searchform'),
                $searchInput = $searchForm.find('#s');

            $searchInput.on('change', function () {
                console.log('changed');
            });
        })();

        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        let dynamicElements = [];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }

        (function() {
            var $frame = $('.frame');
            if ($frame.length !== 0) {
                new Sly($frame, {
                    horizontal: 1,
                    itemNav: 'forceCentered',
                    activateMiddle: 1,
                    smart: 1,
                    activateOn: 'click',
                    mouseDragging: 1,
                    touchDragging: 1,
                    releaseSwing: 1,
                    startAt: 1,
                    scrollBy: 1,
                    activatePageOn: 'click',
                    speed: 200,
                    moveBy: 600,
                    elasticBounds: 1,
                    dragHandle: 1,
                    dynamicHandle: 1,
                    clickBar: 1,
                    // Navigation buttons
                    forward:  null, // Selector or DOM element for "forward movement" button.
                    backward: null, // Selector or DOM element for "backward movement" button.
                    prev:     $('.btn.prev'), // Selector or DOM element for "previous item" button.
                    next:     $('.btn.next'), // Selector or DOM element for "next item" button.
                    scrollBar: $('.o-scrollbar')
                }).init();
            }
        })();

        (function() {
            $('.owl-dot a').on('click', function(e) {
                if(!$(this).parent().hasClass('active')) {
                    e.preventDefault();
                }
            });
        })();

        $(window).on('resize', function () {
            updateDynamicElements();
        });

        function calcFluidPadding() {
            let $container = $('.container');
             return ($( 'body' ).width() - $container.width()) / 2;
        }

        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('#navbarNavDropdown'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            //console.log('click menu');
            mobileMenu.functions.toggle.call(mobileMenu);
            $('#ar-language-switcher').toggleClass('show');
            $('.social-icons-mobile').toggleClass('show');
        });


        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }

        $('#content table').each(function(){
            $(this).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();

        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });

        (function() {
            $('.furniture-menu-button').on('click', function() {
               $('.furniture-m-menu').addClass('show');
            });

            $(".furniture-menu-close-button").on('click', function() {
                $('.furniture-m-menu').removeClass('show');
            });
        })();

        (function(){
            $('*[data-toggle="tooltip"]').tooltip();
        })();

        //language switcher
        (function () {
        
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len =   this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        }  else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

            $(document).on('click', '[data-toggle="lightbox"]', function(event) {
                event.preventDefault();
                $(this).ekkoLightbox();
            });



            $(".open-lightbox").on('click', function(e) {
                e.preventDefault();
                $(".second-gallery a").first().trigger('click');
            });

            $(".form-select").on('change', function() {
                var selectedID = $(this).find(":selected").val();
                $(".forms .form").css("display", "none");
               $(".forms .form-" + selectedID).css("display", "block");
            });

            /* use toggleAffix on any data-toggle="affix" elements */
            var toggleAffix = function(affixElement, scrollElement, wrapper) {

                var height = affixElement.outerHeight(),
                    top = wrapper.offset().top;

                if (scrollElement.scrollTop() >= top){
                    wrapper.height(height);
                    affixElement.addClass("affix");
                }
                else {
                    affixElement.removeClass("affix");
                    wrapper.height('auto');
                }

              };
            // Floating menu
            $('[data-toggle="affix"]').each(function() {
            var ele = $(this),
                wrapper = $('<div class="menu-wrapper"></div>');
            ele.before(wrapper);
            $(window).on('scroll resize', function() {
                toggleAffix(ele, $(this), wrapper);
            });
            // init
            toggleAffix(ele, $(window), wrapper);
            });


            $(".overlay").on('click', function() {
                $(this).removeClass('active');
            });

            if(typeof locations != "undefined") {

                $('#shops-select-country').on('change', function() {
                    var location = $(this).val();

                    switch (location) {
                        case "SI":
                            map.setCenter(46.064190, 14.506348);
                            map.setZoom(8);
                            break;
                        case "HR":
                            map.setCenter(45.195089, 15.510252);
                            map.setZoom(7);
                            break;
                        case "CZ":
                            map.setCenter(49.703578, 15.610517);
                            map.setZoom(7);
                            break;
                        case "SK":
                            map.setCenter(48.752409, 19.575572);
                            map.setZoom(7);
                            break;
                        case "RU":
                            map.setCenter(55.721771, 37.624405);
                            map.setZoom(5);
                            break;
                        case "BG":
                            map.setCenter(42.640492, 25.270170);
                            map.setZoom(7);
                            break;
                        case "BA":
                            map.setCenter(43.995799, 17.887460);
                            map.setZoom(7);
                            break;
                        case "MK":
                            map.setCenter(41.608995, 21.778917);
                            map.setZoom(7);
                            break;
                        case "RS":
                            map.setCenter(43.913685, 20.965205);
                            map.setZoom(7);
                            break;
                        case "HU":
                            map.setCenter(47.119874, 19.648820);
                            map.setZoom(7);
                            break;
                        case "ME":
                            map.setCenter(42.795915, 19.299827);
                            map.setZoom(8);
                            break;
                        case "XK":
                            map.setCenter(42.616217, 20.992535);
                            map.setZoom(8);
                            break;
                    }
                });


                var lang = document.documentElement.lang;

                let lat =  46.1487722;
                let lng = 14.3177721;
                let zoom = 11;

                if(lang == 'hr'){
                    console.log('here');
                    lat = 45.796567;
                    lng = 15.856352;
                    zoom = 14.25;
                }

                var map = new GMaps({ 
                    div: '#map',
                    lat: lat, //46.064190
                    lng: lng, //14.506348
                    zoom: zoom,
                    markerClusterer: function(map, markers) {
                        return new MarkerClusterer(map);
                    }
                });

                for(let i = 0; i < locations.length; i++) {
                    if(typeof locations[i].marker != undefined)
                    map.addMarker({
                        lat: locations[i].lat,
                        lng: locations[i].lon,
                        //icon: localize.site_url + '/wp-content/themes/emigma/assets/icons/map_icon.png',
                        icon: (typeof(locations[i].marker) !== 'undefined' && locations[i].marker)? locations[i].marker : localize.site_url + '/wp-content/themes/emigma/assets/icons/map_icon.png',
                        infoWindow: {
                            content: '<p class="location-name"> ' + locations[i].name + '</p>' +
                                '<p class="location-address">' + locations[i].address + '</p>' +
                                '<p class="location-city d-inline">' + locations[i].city + '</p>&nbsp;' +
                                '<p class="location-postcode d-inline">' + locations[i].postcode + '</p>' +
                                '<div class="location-c-postcode">' +
                                '<a href="tel:' + locations[i].phone +'" class="location-phone">' + locations[i].phone + '</a>' +
                                '</div>' +
                                '<div class="location-email-wrapper">' +
                                '<a href="mailto:' + locations[i].email + '" class="location-email">' + locations[i].email + '</a>' +
                                '</div>' +
                                '<a class="location-link" target="_blank" href="http://maps.google.com/?q=' + locations[i].lat + ',' + locations[i].lon + '">' + locations[i].string + '</a>'
                        }
                    });


                }
            }


        })();

    });

})( jQuery );
